import { render, staticRenderFns } from "./PerformanceReportingInstructions.vue?vue&type=template&id=e8c14da0&"
import script from "./PerformanceReportingInstructions.vue?vue&type=script&lang=js&"
export * from "./PerformanceReportingInstructions.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceReportingInstructions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports